import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Multi-select checklist of the 41 PMBOK process-group document templates,
// grouped by process group. Controlled: `selected` is an array of template
// titles, `onChange` receives the next array.
export default function PmpTemplatePicker({ selected, onChange }) {
  const [templates, setTemplates] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/pmp-templates")
      .then(({ data }) => setTemplates(data || []))
      .finally(() => setLoaded(true));
  }, []);

  const groups = templates.reduce((acc, t) => {
    (acc[t.process_group] = acc[t.process_group] || []).push(t);
    return acc;
  }, {});

  const toggle = (title) => {
    onChange(selected.includes(title) ? selected.filter((t) => t !== title) : [...selected, title]);
  };

  if (!loaded) {
    return <div className="text-xs text-[#6B7280]">Loading templates…</div>;
  }

  return (
    <div className="space-y-4 max-h-80 overflow-y-auto pr-1" data-testid="pmp-template-picker">
      {Object.entries(groups).map(([group, items]) => (
        <div key={group}>
          <div className="text-[11px] uppercase tracking-[0.2em] text-[#00F5D4] mb-1.5">{group}</div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5">
            {items.map((t) => (
              <label
                key={t.title}
                className="flex items-start gap-2 text-xs text-[#D1D5DB] cursor-pointer"
                title={t.has_live_source ? `${t.description} — generated from live project data, not a blank stub.` : t.description}
              >
                <input
                  type="checkbox"
                  className="mt-0.5"
                  data-testid={`pmp-template-${t.title}`}
                  checked={selected.includes(t.title)}
                  onChange={() => toggle(t.title)}
                />
                <span>
                  {t.title}
                  {t.has_live_source && (
                    <span
                      className="ml-1.5 inline-block px-1 py-0.5 text-[9px] uppercase tracking-[0.1em] bg-[#00F5D4]/10 text-[#00F5D4] align-middle"
                      data-testid={`pmp-template-live-badge-${t.title}`}
                    >
                      Live data
                    </span>
                  )}
                </span>
              </label>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
